import classNames from "classnames/bind";
import styles from "./DragUploadImage.module.css";
import Dragger from "antd/es/upload/Dragger";
import { CameraPlus } from "../Icons/CameraControl/CameraPlus";
import Button from "../Button/Button";
import { Image, Upload } from "antd";
import { DeleteIcon, EyeIcon, PlusSolidIcon } from "../Icons/Icons";
import { useState } from "react";
import Toast from "../Toast";
import ImageItem from "./ImageItem";
import PreviewImage from "./PreviewImage";

const cx = classNames.bind(styles)

const DragUploadImage = ({ onChange, fileList, onDelete }) => {
    const [previewImage, setPreviewImage] = useState()
    const [previewOpen, setPreviewOpen] = useState(false)
    const handleCustom = (options) => {
        if (options.onSuccess()) {
            options.onSuccess()
        }
        return 1;
    }
    const propsDrag = {
        multiple: true,
        customRequest: (e) => handleCustom(e),
        style: {
            backgroundColor: '#0040FF12'
        },
        showUploadList: false,
        onChange: (value) => {
            onChange(value?.fileList)
        },
        beforeUpload: (file) => {
            const isPNG = file.type === 'image/png' || file.type === 'image/jpeg';
            if (!isPNG) {
                Toast.open(`${file.name} không phải định dạng hợp lệ`, 'info');
            }
            return isPNG || Upload.LIST_IGNORE;
        },
    };

    const toggleViewFull = (thumbUrl) => {
        setPreviewImage(thumbUrl)
        setPreviewOpen(true)
    }

    const handleDelete = (file) => {
        const files = fileList?.filter(fl => fl?.uid !== file?.uid)
        onChange(files)
        if (file?.id_image) {
            onDelete(file)
        }
    }

    const propUpload = {
        multiple: true,
        listType: "picture-card",
        fileList: fileList,
        customRequest: (e) => handleCustom(e),
        onChange: (value) => {
            onChange(value?.fileList)
        },
        itemRender: (originNode, file) => {
            return (
                <ImageItem file={file} handleDelete={handleDelete} toggleViewFull={toggleViewFull} />
            )
        },
        beforeUpload: (file) => {
            const isPNG = file.type === 'image/png' || file.type === 'image/jpeg';
            if (!isPNG) {
                Toast.open(`${file.name} không phải định dạng hợp lệ`, 'info');
            }
            return isPNG || Upload.LIST_IGNORE;
        },
    }
    return (
        <div className={cx('wrapper')}>
            {
                fileList?.length > 0 ?
                    <Upload
                        {...propUpload}
                        className={cx('upload-select')}
                    >
                        <div className={cx('image', 'default')}>
                            <PlusSolidIcon />
                            <p className={cx('label')}>Upload ảnh</p>
                        </div>
                    </Upload> :
                    <Dragger {...propsDrag}>
                        <div className={cx('drager-content')}>
                            <CameraPlus />
                            <p className={cx('title-drager')}>Kéo thả ảnh tại đây.</p>
                            <p className={cx('noti-drager')}>Định dạng JPG, JPEG, PNG</p>
                            <p className={cx('option-drager')}>hoặc</p>
                            <div className={cx('wrap-btn')}>
                                <Button title={'Chọn ảnh từ máy tính'} onClick={() => 0} className={cx('btn-upload')} />
                            </div>
                        </div>
                    </Dragger>
            }
            {previewImage && (
                <PreviewImage previewImage={previewImage} previewOpen={previewOpen} setPreviewImage={setPreviewImage} setPreviewOpen={setPreviewOpen} />
            )}
        </div>
    )
}

export default DragUploadImage;